import { render } from "./downloadLog.vue?vue&type=template&id=64fdb903"
import script from "./downloadLog.vue?vue&type=script&lang=js"
export * from "./downloadLog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__